export default "__VITE_ASSET__B8_Qr_az__"